module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAFHBAMAAACMhAvMAAAAIVBMVEUAAAAnsicbrhocrhkbrhserh4brRobrhoetB4brhoarRk+EbtJAAAACnRSTlMADdplQSjFvRG85BLkZQAAAFRJREFUSMdjEFoFBgsYWGAMhlkwhhWMEQVjSGEwojAUV6Eb2ARjZMEYqyhjZMFNxnR81ajjRx0/6vhRx486ftTxo44fdfyo40cdP9COn4VmILzVDQD7JxXlC8ixBQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/discount-line.png
// module id = 1904
// module chunks = 6